import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import nodeinstance from "../../nodeInstance";

const DEFAULT_META = {
  total: 0,
  page: 1,
  limit: 50,
  totalPages: 1,
};

const getLocalTrasferData = createAsyncThunk(
  "/localtrasfer",
  async (
    { token, page = 1, limit = 50, search = "" } = {},
    { rejectWithValue }
  ) => {
    try {
      const params = { page, limit };
      if (search && search.trim()) params.search = search.trim();
      const response = await nodeinstance.get("/dashboard/localTransfer", {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      return {
        data: response?.data?.data || [],
        meta: response?.data?.meta || { ...DEFAULT_META, page, limit },
      };
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message);
    }
  }
);

const localDataSlice = createSlice({
  name: "localtrasfer",
  initialState: {
    data: null,
    meta: DEFAULT_META,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocalTrasferData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.meta = action.payload.meta || DEFAULT_META;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getLocalTrasferData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getLocalTrasferData.rejected, (state, action) => {
        state.isLoading = false;
        state.status = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export { getLocalTrasferData };
export default localDataSlice.reducer;
